import { h } from 'preact'

/** @jsx h */

const impactIcons = RAILS_ASSET_URL('/sprites/impact-icons.svg')

const ImpactIcon = ({ icon }) =>
  <svg className="sprite-icon">
    <use href={[ impactIcons, icon ].join('#')} />
  </svg>

export default ImpactIcon
